import React from 'react';
import { ApolloClientProvider } from '@atlassian/jira-apollo-multiple-clients/src/main.tsx';
import swagClient from '@atlassian/jira-apollo-swag';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import Spinner from '@atlassian/jira-software-report-charting-common/src/ui/spinner/index.tsx';
import ReportPage from '@atlassian/jira-software-report-page';
import { REPORT_CUMULATIVE_FLOW_DIAGRAM } from '@atlassian/jira-software-report-page/src/common/constants.tsx';
import { APP_ID } from './common/constants';
import View from './ui';
import Controls from './ui/controls';

export type Props = {
	readonly boardId: number;
};

export function CumulativeFlowDiagram({ boardId }: Props) {
	const children = __SERVER__ ? (
		<>
			<Controls isDisabled lowerOpacity={false} />
			<Spinner />
		</>
	) : (
		<View boardId={boardId} />
	);

	return (
		<ApolloClientProvider client={swagClient}>
			<AppBase
				id={APP_ID}
				teamName="helios-reports"
				packageName="@atlassian/jira-software-cumulative-flow-diagram"
			>
				<AppStyle>{children}</AppStyle>
			</AppBase>
		</ApolloClientProvider>
	);
}

type AppProps = {
	readonly boardId: number;
	readonly projectKey: string;
	readonly baseUrl: string;
};

const App = (props: AppProps) => {
	const { baseUrl, projectKey, boardId } = props;

	return (
		<ReportPage
			baseUrl={baseUrl}
			projectKey={projectKey}
			boardId={boardId}
			reportType={REPORT_CUMULATIVE_FLOW_DIAGRAM}
		>
			<CumulativeFlowDiagram boardId={boardId} />
		</ReportPage>
	);
};

export default App;
